import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'

const BOTTOM_CTA_POSTER_SRC = '/assets/landing/feature-outplacement.webp'

export function LandingBottomVideoCtaSection() {
  return (
    <section className="relative bg-white scroll-fade-up">
      <div className="relative w-full px-4 md:px-24 py-12 md:py-32 overflow-hidden flex items-center justify-center min-h-[320px] md:min-h-[500px]">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={BOTTOM_CTA_POSTER_SRC}
          className="absolute inset-0 max-w-none object-cover w-full h-full"
          controlsList="nodownload"
        >
          <source
            src="https://videos.pexels.com/video-files/853870/853870-hd_1920_1080_25fps.mp4"
            type="video/mp4"
          />
          <img
            src={BOTTOM_CTA_POSTER_SRC}
            alt="Team collaborating in an office"
            className="absolute inset-0 max-w-none object-cover w-full h-full"
          />
        </video>
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative flex flex-col gap-4 md:gap-8 items-center text-center max-w-[1280px] w-full">
          <h2 className="text-3xl md:text-[64px] font-display text-white leading-none tracking-[-0.6px] md:tracking-[-1.28px] max-w-4xl">
            We're on a mission to destigmatize job loss.
          </h2>
          <p className="text-base md:text-xl font-normal text-white leading-[1.5] max-w-[768px] tracking-[-0.32px] md:tracking-[-0.4px]">
            Pelgo replaces fragmented vendors and internal inefficiencies with a modular solution
            that doesn't feel like it was built 20 years ago.
          </p>
          <Button
            asChild
            className="bg-pelgo-blue-light hover:bg-pelgo-blue-light/90 text-white rounded-full px-6 py-3 text-base font-semibold min-h-[48px]"
          >
            <Link to="/contact">Request Free Trial</Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
